const SESSION_KEY = 'dsm-web-session'

export type Session = {
  username: string
  licenseExpiry: string
}

export function getSession(): Session | null {
  const raw = sessionStorage.getItem(SESSION_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as Session
  } catch {
    sessionStorage.removeItem(SESSION_KEY)
    return null
  }
}

export async function login(username: string, password: string): Promise<Session> {
  // Vite 단독 개발 서버에는 Pages Function이 없으므로 기본 guest 계정만 허용합니다.
  if (import.meta.env.DEV && username === 'guest' && password === 'guest') {
    const session = { username, licenseExpiry: '2099-12-31' }
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
    return session
  }

  const response = await fetch('/api/validate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  })

  if (!response.ok) {
    throw new Error(response.status === 401 ? '아이디 또는 비밀번호가 올바르지 않습니다.' : '로그인 요청에 실패했습니다.')
  }

  const session = { username, licenseExpiry: await response.text() }
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session))
  return session
}

export function logout() {
  sessionStorage.removeItem(SESSION_KEY)
}
